import * as Sentry from "@sentry/react";
import React from "react";

import CompanyMeetings from "./components/CompanyMeetings";

const CompanyMeetingsPage = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<CompanyMeetings />
		</Sentry.ErrorBoundary>
	);
};

export default CompanyMeetingsPage;
